module.exports = __webpack_public_path__ + "static/img/challenger.092bfa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/league-ad-section/challenger.png
// module id = flB3
// module chunks = 35